import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PortalService } from '../../../../../services/portal.service';
import { EnrollmentFormService } from '../../../../../services/EnrollmentFormService';
@Component({
  selector: 'app-drug-selection',
  templateUrl: './drug-selection.component.html',
  styleUrls: ['./drug-selection.component.scss']
})
export class DrugSelectionComponent implements OnInit{
  options: string[] = ['Option 1', 'Option 2', 'Option 3'];
  selectedOption: string | null = null;
  drugList: any;

  constructor(
    public dialogRef: MatDialogRef<DrugSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private portalService : PortalService,
    private efs : EnrollmentFormService
  ) {}
  ngOnInit(){
    this.getDrugList();
  }
  close(): void {
    this.dialogRef.close();
  }

  // Confirm the selection and navigate to the next step
  confirm(): void {
    const selectedDrug = this.drugList.find((drug: { drugID: string; drugName: string }) =>
      drug.drugID == this.selectedOption
    );

    if(this.selectedOption){
      this.efs.resetForm();
      this.efs.setDrugDetails( selectedDrug.drugName,selectedDrug.drugID);
      this.dialogRef.close(this.selectedOption); 
      this.router.navigate(['/enrollment/Profile']); 
      localStorage.setItem('CurrentEnrollmentStep', '1');
    }
  }

  getDrugList(){
    this.portalService.getDrugList().subscribe((data :any)=>{
      if (data) {
        this.drugList = data;
        console.log(this.drugList);
      }
    })
  }

}
